export function PlayIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="22" r="22" fill="white" />
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8287 28.2772L26.5694 22.3976C26.7775 22.2161 26.799 21.9002 26.6175 21.6921C26.6029 21.6754 26.5872 21.6597 26.5705 21.645L19.8298 15.7284C19.6223 15.5462 19.3064 15.5668 19.1242 15.7743C19.0442 15.8655 19 15.9828 19 16.1041V27.9004C19 28.1765 19.2239 28.4004 19.5 28.4004C19.6208 28.4004 19.7376 28.3566 19.8287 28.2772Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
export default PlayIcon;
